import { useFormik } from "formik";
import * as yup from "yup";
import TextInput from "../../../../../components/inputs/textInput";
import Button from "../../../../../components/buttons/button";
import DateInput from "../../../../../components/inputs/dateInput";
const SalariesEdit = ({ t, setOpen }) => {
  const validationSchema = yup.object({
    baseSalary: yup.string().required(t("required")),
  });
  const formik = useFormik({
    initialValues: {
      baseSalary: "",
    },
    validationSchema,
    onSubmit: (values) => {
      console.log(values);
      setOpen(false);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4">
      <div>
        <TextInput formik={formik} name={"baseSalary"} label={t("baseSalary")} />
      </div>
      <div className="inputs">
        <TextInput formik={formik} name={"bonus"} label={t("bonus")} />
        <TextInput formik={formik} name={"bonusReason"} label={t("bonusReason")} />
      </div>
      <div className="inputs">
        <TextInput formik={formik} name={"deduction"} label={t("deduction")} />
        <TextInput
          formik={formik}
          name={"deductionReason"}
          label={t("deductionReason")}
        />
      </div>
      <div className="inputs">
        <DateInput
          dateFormat={"yyyy/MM"}
          formik={formik}
          label={t("currentMonth")}
          name={"currentMonth"}
        />
      </div>
      <div className="bg-[#1C294D] border-primary border p-4 rounded-xl space-y-2">
        <p className="flex items-center font-medium">
          <span className="block w-full text-mainGray">{t("baseSalary")}:</span>
          <span className="block w-full">{formik.values.baseSalary || 0}</span>
        </p>
        <p className="flex items-center font-medium text-[#902929]">
          <span className="block w-full">{t("deduction")}:</span>
          <span className="block w-full">{formik.values.deduction || 0}-</span>
        </p>
        <p className="flex items-center font-medium text-[#71EB77]">
          <span className="block w-full">{t("bonus")}:</span>
          <span className="block w-full">{formik.values.bonus || 0}+</span>
        </p>
      </div>
      <div className="flex items-center justify-end gap-3">
        <Button
          className={"border border-white text-sm"}
          type="button"
          onClick={() => setOpen(false)}
        >
          {t("cancel")}
        </Button>
        <Button className={"bg-primary justify-center w-[130px] text-black text-sm"}>
          {t("save")}
        </Button>
      </div>
    </form>
  );
};

export default SalariesEdit;
